<script setup>
// "Did you mean jane@gmail.com?" under an email field, with the fix one
// tap away. lib/emailTypos.js decides, which is the twin of the
// server's App\Support\Mail\EmailTypos, so what this offers is what the
// server would refuse. Runs offline, which is the field app's case.
//
// Plain colors from the surrounding text, so it sits on an
// organization's own site template as well as in the app.
import { computed } from 'vue';
import { suggestEmail } from '@/lib/emailTypos';

const props = defineProps({ email: { type: String, default: '' } });
const emit = defineEmits(['fix']);

const suggestion = computed(() => suggestEmail(props.email));
</script>

<template>
    <p v-if="suggestion" class="tiq-email-typo" data-email-typo role="status">
        Did you mean
        <button type="button" class="tiq-email-typo__fix" data-email-typo-fix @click="emit('fix', suggestion)">{{ suggestion }}</button>?
    </p>
</template>

<style scoped>
.tiq-email-typo {
    margin: 4px 0 0;
    font-size: 13px;
    line-height: 1.4;
    color: inherit;
    opacity: 0.85;
}
.tiq-email-typo__fix {
    padding: 0;
    border: 0;
    background: none;
    color: inherit;
    font: inherit;
    font-weight: 700;
    text-decoration: underline;
    cursor: pointer;
}
</style>
